import Vuex from 'vuex';
import Store from './components/store';
import bootbox from './bootbox.min';
import introJs from './intro.js';
import VueMask from 'v-mask';
import lozad from 'lozad';
import VueSweetalert2 from 'vue-sweetalert2';
import {ptBR} from 'vuejs-datepicker/dist/locale';

import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/css/froala_editor.pkgd.min.css';

import VueFroala from 'vue-froala-wysiwyg'

window.$ = window.jQuery = require('jquery/dist/jquery');
window.Vue = require('./vue2-prod.min');
window.axios = require('axios');
window.bootbox = bootbox;
window.tour = introJs.introJs();
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.io = require('socket.io-client');

require('vue-select/dist/vue-select.css');
// require('./sentry.js');

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if(error &&
      error.response &&
      error.response.status &&
      error.response.status === 401)
    window.location.href = "/login";
  return Promise.reject(error);
});

Vue.config.devtools = true;
Vue.config.ignoredElements = ['alias'];

require('@/components');

Vue.use(Vuex);
Vue.use(VueMask);
Vue.use(VueSweetalert2);
Vue.use(VueFroala)

const store = new Vuex.Store(Store);

const app = new Vue({
  el: '#app',

  store,

  mounted() {
    this.searchForFlashMessageOnMounted();

    /*Scroll to top when arrow up clicked BEGIN*/
    $(window).scroll(function() {
      ($(window).scrollTop() > 100) ? $('#back2Top').fadeIn() : $('#back2Top').fadeOut();
    });

    $(document).ready(function() {
      $('#back2Top').click(function(event) {
        event.preventDefault();
        window.scroll({top: 0, left: 0, behavior: 'smooth'});
        return false;
      });

    });
    /*Scroll to top when arrow up clicked END*/

  },

  data() {
    return {
      datepickerLang: ptBR,
    }
  },

  methods: {
    initTour() {
      if (window.location.pathname != '/') {
        if (window.location.pathname === '/online/posters') {
          tour.setOptions({
            'exitOnOverlayClick': false,
            'showStepNumbers': false,
            'showProgress': true,
            'doneLabel': 'Sair',
            'prevLabel': 'Anterior',
            'nextLabel': 'Próximo',
            'skipLabel': 'Pular',
            steps: [
              {
                intro: 'Em "Gestão de Ofertas" ficam todos os cartazes já criados. ' +
                  'Aqui podemos imprimir, duplicar, editar e até mesmo buscá-los.',
              },
              {
                element: '#btn-duplicate-0',
                position: 'left',
                disableInteraction: true,
                intro: 'Clique neste botão para duplicar o cartaz. Você pode duplicar quantas vezes forem necessárias.',
              },
              {
                element: '#btn-preview-0',
                position: 'left',
                disableInteraction: true,
                intro: 'Clique neste botão para ver o cartaz.',
              },
              {
                element: '#btn-show-0',
                position: 'left',
                disableInteraction: true,
                intro: 'Clique neste botão para ver informações sobre o cartaz.',
              },
              {
                element: '#btn-edit-0',
                position: 'left',
                disableInteraction: true,
                intro: 'Clique neste botão para editar o cartaz.',
              },
              {
                element: '#checkbox-0',
                disableInteraction: true,
                intro: 'Clique nos quadrados ao lado do código para selecionar os cartazes a serem impressos. Selecione apenas formatos iguais.',
              },
              {
                element: '#printWithThemeCheckbox',
                disableInteraction: true,
                intro: 'Deixe "imprimir com tema" selecionado para imprimir todo o cartaz em folha branca ou amarela. ' +
                  'Caso seu papel seja pré-impresso, clique no quadrado para imprimir sem tema (imprimir apenas descrições e valores). ' +
                  'Você pode definir a seleção padrão clicando em Configurações > Preferências de usuário.',
              },
              {
                element: '#printButton',
                disableInteraction: true,
                intro: 'Clique em "IMPRIMIR CARTAZES" para imprimir os cartazes selecionados.',
              },
              {
                element: '#exportButton',
                disableInteraction: true,
                intro: 'Clique em "Imprimir PDF" para imprimir o pdf dos cartazes selecionados.',
              },
              {
                element: '#products-menu',
                intro: 'Passe o mouse em "BANCO DE DADOS" e clique em produtos para importar os produtos de sua loja.',
              },
            ].filter(function(obj) {
              return $(obj.element).length || !obj.element;
            }),
          }).start();
        } else {
          tour.setOptions(
            {
              'exitOnOverlayClick': false,
              'exitOnEsc': false,
              'showStepNumbers': false,
              'showProgress': true,
              'tooltipPosition': 'auto',
              'doneLabel': 'Avançar',
              'prevLabel': 'Anterior',
              'nextLabel': 'Próximo',
              'skipLabel': 'Pular',
              'scrollToElement': false,
            }).oncomplete(function() {
            window.location.href = '/online/posters';
          }).start();
        }
      } else {
        tour.setOptions(
          {
            'exitOnOverlayClick': false,
            'showStepNumbers': false,
            'showButtons': false,
            'showBullets': false,
            'skipLabel': 'Pular',
          }).start();
      }
    },

    searchForFlashMessageOnMounted() {
      $('.callback-flash .flash-message').each((index, flash) => {
        const flashDiv = $(flash).children();
        const type = /alert-(\w+)/.exec(flashDiv.attr('class'))[1];
        const message = $(flashDiv).find('p').html();

        this.throwFlashMessage(type, message);
      });
    },

    throwFlashMessage(type, message) {
      type = (type === 'danger') ? 'error' : type;

      let background = 'white';
      let color = '#545454';

      switch (type) {
        case 'success':
          background = '#d4edda';
          color = '#155724';
          break;
        case 'warning':
          background = '#fff3cd';
          color = '#856404';
          break;
      }

      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: type,
        title: "<span style='color:" + color + "'>" + message + "</span>",
        background: background,
        onOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer);
          toast.addEventListener('mouseleave', this.$swal.resumeTimer);
        },
      });
    },

    lazyImages: _.debounce(function() {
      let images = document.querySelectorAll('.lazy-load');

      if (window.imageObserver && window.imageObserver.observer) {
        window.imageObserver.observer.disconnect();
        delete window.imageObserver;
        for (let i = 0, len = images.length; i < len; i++) {
          images[i].setAttribute('src', '/img/loading.svg');
          // load image only when the image src is updated
          const img = images[i].getAttribute('data-src') || false;

          const isLoaded = images[i].getAttribute('data-loaded') === 'true';

          if (img && isLoaded && img !== images[i].getAttribute('src')) {
            images[i].setAttribute('data-loaded', false);
          }
        }
      }
      window.imageObserver = lozad(images);
      window.imageObserver.observe();
    }, 500),
  },
});




// WEBPACK FOOTER //
// ./resources/assets/js/main.js